<template>
  <base-page-layout class="usuarios" title="Usuários">
    <v-layout>
      <v-spacer />
      <v-btn class="mb-3" color="primary" text @click="openNewUser">Novo usuário</v-btn>
    </v-layout>
    <v-card>
      <v-card-title class="pa-5">
        <v-row no-gutters>
          <v-col cols="9">
            <span class="table-card-title"> Usuários cadastrados </span>
          </v-col>
          <v-col cols="3">
            <mf-search v-model="search" class="pt-0 mt-0" hide-details placeholder="Busca" width="310px" />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="px-5 pb-5">
        <paginated-data-table ref="table" :headers="headers" :query="query" query-main-property-name="users" query-name="getPlatformUsers" :search="search">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>
                <span :class="item.active ? 'status-ativo' : 'status-inativo'">{{ item.active ? 'Ativo' : 'Inativo' }}</span>
              </td>
              <td>
                <span :class="item.active ? 'status-ativo' : 'status-inativo'">{{ item.emailConfirmed ? 'Confirmado' : 'Não confirmado' }}</span>
              </td>
              <td align="right">
                <v-menu v-if="userCanSeeMenu(item)">
                  <template v-slot:activator="{ on }">
                    <v-btn icon text v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="openEditUser(item)">
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="enableDisableUser(item)">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.active === false ? 'Ativar' : 'Desativar' }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="openLogsModal(item._id)">
                      <v-list-item-content>
                        <v-list-item-title>Logs</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </paginated-data-table>
      </v-card-text>
    </v-card>
    <user-form v-model="dialog" :email="selectedUser.email" @get-data="getUsers" />
    <logs-modal v-model="logsDialog" :idItem="userId" logTitle="usuarios" tags="USER" />
  </base-page-layout>
</template>

<script>
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import UserForm from '@/modules/usuarios/views/components/UserForm.vue'
import BasePageLayout from '@/components/BasePageLayout.vue'
import LogsModal from '@/components/logs-modal/LogsModal.vue'
import { QUERY_GET_USERS, MUTATION_UPDATE_USER } from '@/modules/usuarios/graphql'

export default {
  components: {
    BasePageLayout,
    PaginatedDataTable,
    UserForm,
    LogsModal,
  },
  data: () => ({
    search: '',
    logsDialog: false,
    dialog: false,
    userId: '',
    selectedUser: {},
  }),
  computed: {
    query() {
      return QUERY_GET_USERS
    },
    headers() {
      return [
        {
          text: 'Nome',
          sortable: false,
        },
        {
          text: 'Email',
          sortable: false,
        },
        {
          text: 'Status',
          sortable: false,
        },
        {
          text: 'E-mail confirmado',
          sortable: false,
        },
        {
          text: '',
          sortable: false,
          align: 'right',
        },
      ]
    },
  },
  methods: {
    openEditUser(user) {
      this.selectedUser = user
      this.dialog = true
    },
    async enableDisableUser(user) {
      const confirmed = await this.$confirm({
        title: `${!user.active ? 'Ativar' : 'Desativar'} usuário`,
        message: `Você tem certeza que deseja ${!user.active ? 'ativar' : 'desativar'} o usuário?`,
        confirmText: !user.active ? 'Ativar' : 'Desativar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)

      if (!confirmed) return
      user.active = !user.active
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_USER,
          variables: user,
        })
        this.$snackbar({ message: `Usuário ${user.active ? 'ativado' : 'desativado'} com sucesso` })
      } catch (error) {
        this.$snackbar({ message: `Não foi possível ${user.active ? 'ativar' : 'desativar'} este usuário` })
        user.active = !user.active
      }
    },
    openNewUser() {
      this.selectedUser = {}
      this.dialog = true
    },
    getUsers() {
      this.$refs.table.waitAndGetData()
    },
    isAccessSensitiveData(user) {
      return user?.permissions?.crm?.accessSensitiveData
    },
    isAccessSensitiveDataEmployees(user) {
      return user?.permissions?.crm?.accessSensitiveDataEmployees
    },
    userCanSeeMenu(user) {
      const {
        permissions: { crm, ecommerce },
      } = user

      if ((this.$getIsClub() && !!crm.permissions.length) || (this.$getIsEcommerce() && !!ecommerce.permissions.length)) {
        return true
      }
      return false
    },
    openLogsModal(id) {
      this.userId = id
      this.logsDialog = true
    },
  },
}
</script>

<style lang="scss">
.usuarios {
  .status-ativo {
    color: $verde-0;
  }
  .status-inativo {
    opacity: 0.38;
  }
}
.user-table {
  margin-top: 15px;
  .table-top {
    display: flex;
    padding: 24px 24px 32px;
    &-csv {
      font-size: 12px;
      letter-spacing: 0.01em;
      color: $marca-0-l40 !important;
      text-transform: none;
      -webkit-text-decoration-line: none;
      text-decoration-line: none;
      margin-right: 20px;
      align-self: center;
    }
    &-search {
      max-width: 260px;
    }
  }
  .headers-grouping {
    th {
      height: 21px;
      border-bottom: none !important;
      font-size: 14px;
      color: $cinza-d20 !important;
      padding-bottom: 8px;
    }
    &__item {
      border-left: 1px solid #9a9a9a !important;
      font-weight: 400;
    }
  }
  th {
    padding-bottom: 11px;
    border-bottom: 1px solid #9a9a9a !important;
    &.text-left {
      font-size: 12px;
      line-height: 14px;
      color: $cinza-d10;
      font-weight: 400;
      padding-bottom: 11px;
      height: 14px;
    }
  }
  .left-line {
    border-left: 1px solid $cinza-l30;
  }
  .v-data-table__progress th {
    padding: 0;
  }
}
</style>
